export default __webpack_public_path__ + "static/media/matt.edb8a3aa.jpeg";